module.exports = __webpack_public_path__ + "static/ActaAgate-Book-6423e302065bf57e14c5e46b0c9ae522.woff";